import React, { useEffect, useState } from 'react';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookiesAccepted');
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: '#222',
      color: '#fff',
      padding: '1rem',
      textAlign: 'center',
      fontSize: '0.9rem',
      zIndex: 9999
    }}>
      <p style={{ margin: 0 }}>
        Este sitio utiliza cookies técnicas para mejorar tu experiencia. Al continuar navegando, aceptas su uso.{' '}
        <a href="/políticas/politica-de-cookies.html" style={{ color: '#ffcc00', textDecoration: 'underline' }}>
          Saber más
        </a>
      </p>
      <button
        onClick={handleAccept}
        style={{
          marginTop: '0.5rem',
          padding: '0.4rem 1rem',
          background: '#ffcc00',
          border: 'none',
          color: '#000',
          cursor: 'pointer',
          fontWeight: 'bold'
        }}
      >
        Aceptar
      </button>
    </div>
  );
};

export default CookieBanner;
